import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlNumeric extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Numeric;
}
